<template>
  <v-container>
    <v-card class="elevation-3 mt-3">
      <v-container class="pt-0">
        <v-layout row wrap>
          <v-flex xs12>
            <v-toolbar color="white" text class="mt-0 pt-0 elevation-0">
              <v-toolbar-title class="subtitle-1 font-weight-medium">Editar Ambulância</v-toolbar-title>
            </v-toolbar>
          </v-flex>

          <v-flex xs8>
            <v-card-text>
              <FormAmbulanceInfo ref="formAmbulance" :ambulance="ambulanceObj"/>
            </v-card-text>
          </v-flex>

          <v-flex xs12 class="pl-12">
            <v-btn
              class="body-2 white--text"
              @click="editAmbulance"
              color="primary"
              depressed
              :loading="loading"
            >
              Editar Ambulância
            </v-btn>
          </v-flex>

        </v-layout>
      </v-container>
    </v-card>
  </v-container>
</template>

<script>
import FormAmbulanceInfo from '../../../components/admin/ambulance/FormAmbulanceInfo'
import moment from 'moment'
export default {
  name: "NewHospital",
  props:['id'],
  components:{
    FormAmbulanceInfo
  },
  data: () => ({
    loading:false
  }),
  computed: {
    ambulanceObj(){
      return this.$store.getters.ambulances[this.id]
    }
  },
  methods: {
    editAmbulance(){

      let formAmbulance = this.$refs.formAmbulance.setAmbulanceInfo()
      if(formAmbulance){
        this.loading = true
        let obj = {id:this.id,
          ...formAmbulance,
          date:moment().format('DD/MM/YYYY')
        }
        this.$store.dispatch('editAmbulance',obj)
        this.loading = false
        this.$router.back()
      }
    }
  }
};
</script>

<style>
</style>
